var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 10C13 8.61667 11.8833 7.5 10.5 7.5C9.11667 7.5 8 8.61667 8 10C8 11.3833 9.11667 12.5 10.5 12.5C10.8417 12.5 11.175 12.4333 11.475 12.3",
    stroke: "#6F7273",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2334 17.1509L7.14173 17.6759C7.80006 18.0676 8.65007 17.8342 9.04173 17.1759L9.1334 17.0176C9.8834 15.7092 11.1167 15.7092 11.8751 17.0176L11.9667 17.1759C12.3584 17.8342 13.2084 18.0676 13.8667 17.6759L15.3084 16.8509C16.0667 16.4176 16.3251 15.4426 15.8917 14.6926C15.1334 13.3842 15.7501 12.3176 17.2584 12.3176C18.1251 12.3176 18.8417 11.6092 18.8417 10.7342V9.26758C18.8417 8.40091 18.1334 7.68425 17.2584 7.68425C16.4167 7.68425 15.8501 7.35091 15.6501 6.82591C15.4917 6.41758 15.5584 5.88425 15.8917 5.30925C16.3251 4.55091 16.0667 3.58424 15.3084 3.15091L14.6334 2.76758",
    stroke: "#6F7273",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8667 2.98385C11.1167 4.29218 9.88342 4.29218 9.12508 2.98385L9.03341 2.82552C8.65008 2.16718 7.80008 1.93385 7.14175 2.32552L5.70008 3.15052C4.94175 3.58385 4.68341 4.55885 5.11675 5.31718C5.87508 6.61718 5.25841 7.68385 3.75008 7.68385C2.88341 7.68385 2.16675 8.39218 2.16675 9.26718V10.7339C2.16675 11.6005 2.87508 12.3172 3.75008 12.3172C5.25841 12.3172 5.87508 13.3839 5.11675 14.6922",
    stroke: "#6F7273",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.ac08583a910a8df310f96b01d0614b23.svg";
export { ForwardRef as ReactComponent };